import { BaseDto } from 'src/dtos/common/baseDto';
import { formatDate } from 'src/utils/string/stringUtil';

export interface moldDto extends BaseDto {

	moldCd: string;
	moldNm: string;
	moldType: string;
	moldClass: string;
	cavity: number;
	purchaseAmt: number;
	itemCd: string;
	makerNm: string;
	makeDt: string;
	purchaseDt: string;
	shotLimit: number;
	currentShot: number;
	cleanCycle: number;
	eqmstatus: string;
	useYn: string;
	moldImage: string;
	remark: string;

	inserted: boolean;
	isModified: boolean;
}

export const defaultMoldDto: moldDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	moldCd: '',
	moldNm: '',
	moldType: '',
	moldClass: '',
	cavity: 0,
	purchaseAmt: 0,
	itemCd: '',
	makerNm: '',
	makeDt: formatDate(new Date()),
	purchaseDt: formatDate(new Date()),
	shotLimit: 0,
	currentShot: 0,
	cleanCycle: 0,
	eqmstatus: '',
	useYn: '',
	moldImage: '',
	remark: '',

	inserted: false,
	isModified: false
}
